import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=419491c4&scoped=true"
import script from "./faq.vue?vue&type=script&setup=true&lang=js"
export * from "./faq.vue?vue&type=script&setup=true&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=419491c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419491c4",
  null
  
)

export default component.exports